window.addEventListener('load', () => {
  Utils.setDatepicker();
  Utils.setSelect2();
});

/**
 * 공통함수
 */
const Utils = (function () {
  let global = {};
  let tabulatorData = {};

  init();

  /**
   * Initialize (Only Once)
   */
  function init() {
    setHeaderEvent();
    setCommonEvent();
    setTooltip();
    //setTableCheckbox();
    setTableBtn();
    setBtnEvent();
  }
  /**
   * Set Header Tab Event For Accessibility
   */
  function setHeaderEvent() {
    const $btnMobileMenu = $('.navbar-nav.mobile a');
    const $mobileMenu = $('.navbar.mobile');
    const $navItem = $('.layout-header .navbar-nav .nav-item');
    const $navLink = $('.navbar-brand, .layout-header .navbar-nav li > a');
  
    // #region mobile menu event
    $btnMobileMenu.on('click', () => {
      $('.layout-header').append('<div class="header-backdrop modal-backdrop fade"></div>');
      $mobileMenu.addClass('active');
      $mobileMenu.addClass('visible');
      setTimeout(() => {
        $('.header-backdrop').addClass('show');
      }, 100);
    });
    $(document).on('click', '.header-backdrop, .btn-navbar-close', () => {
      $('.header-backdrop').removeClass('show');
      $mobileMenu.removeClass('active');
      setTimeout(() => {
        $('.header-backdrop').remove();
        $mobileMenu.removeClass('visible');
      }, 300);
    });
    // #endregion mobile menu event
    // #region tab event
    $navItem.on('focusin', function () {
      removeMenuActive();
      $(this).addClass('active');
    });
    $navItem.on('click', function () {
      $navItem.removeClass('active-only');
      $(this).addClass('active-only');
      $(this).removeClass('active');
    });
    $navLink.on('focusin', function () {
      removeMenuActive();
    });
    $(document).on('mousedown', function () {
      removeMenuActive();
    });
    $('.layout-main, .layout-footer').on('focusin', function () {
      removeMenuActive();
    });
    function removeMenuActive() {
      $('.layout-header .navbar-nav .nav-item').removeClass('active');
    }
    // #endregion tab event
  }
  /**
   * Set Common Event
   */
  function setCommonEvent() {
    // 모달 open/close 스크롤 이벤트
    let scrollTop;
    $(document).on('show.bs.modal', function () {
      scrollTop = $(window).scrollTop();
      $('html').css({
        overflow: 'hidden',
        position: 'fixed',
        top: `-${scrollTop}px`,
        width: '100%'
      });
    });
    $(document).on('hidden.bs.modal', function () {
      $('html').css({
        overflow: 'unset',
        position: '',
        top: '',
        width: ''
      });
      $(window).scrollTop(scrollTop);
    });
    // #region password event
    $(document).on('click', '.btn-password-view', function () {
      const $input = $(this).parents('.password-container').find('input');

      if ($(this).text() == 'visibility_off') {
        $input.attr('type', 'text');
        $(this).find('i').text('visibility');
      } else {
        $input.attr('type', 'password');
        $(this).find('i').text('visibility_off');
      }
    });
    // #endregion password event
    // #region step event
    $(document).on('click', '.btn-step', function () {
      let count = 0;
      const fnStepEvent = () => {
        if (count >= 10) return;
        setTimeout(() => {
          const $container = $(this).closest('.login-main, .step-main');
          const $containerInner = $(this).closest('.login-main-inner, .step-main-inner');
          const $currentSectionForm = $(this).closest('section').parent('form').length > 0 ? $(this).closest('section').parent('form') : $(this).closest('section');
          const $currentSection = $(this).closest('section');
          const $targetForm = $($(this).attr('data-target')).parent('form').length > 0 ? $($(this).attr('data-target')).parent() : $($(this).attr('data-target'));
          const $target = $($(this).attr('data-target'));

          // modal size 변경
          if ($target.closest('.modal') && $target.attr('data-size')) {
            $target.closest('.modal-dialog').removeClass('modal-sm modal-md modal-lg modal-xl modal-xxl');
            $target.closest('.modal-dialog').addClass($target.attr('data-size'));
          }

          if ($target.length == 0) {
            fnStepEvent();
          } else {
            $target.css('display', 'block');
            if ($targetForm.index() > 0) {
              $container.find('h1').css('display', 'none');
            } else {
              $container.find('h1').css('display', 'block');
            }
            if ($targetForm.index() > $currentSectionForm.index()) {
              $containerInner.css('transform', `translateX(-${$target.outerWidth(true)}px)`);
            } else {
              $containerInner.addClass('no-animate');
              $containerInner.css('transform', `translateX(-${$target.outerWidth(true)}px)`);
              setTimeout(function () {
                $containerInner.removeClass('no-animate');
                $containerInner.css('transform', 'translateX(0)');
              }, 10);
            }
            setTimeout(function () {
              $containerInner.addClass('no-animate');
              $currentSection.css('display', 'none');
              $containerInner.css('transform', 'translateX(0)');
              setTimeout(function () {
                $containerInner.removeClass('no-animate');
              }, 100);
            }, 310);
          }
        }, 100);
        count++;
      };
      fnStepEvent();
    });
    // #endregion step event
    // #region number list event
    $(document).on('click', '.btn-code-request', function () {
      const $codeInput = $(this).parents('.input-group').find('input.form-request-title');
      const $target = $($(this).attr('data-target'));

      $target.find('.target-email').html($codeInput.val());
      $target.find('.custom-invalid-feedback').html("인증시간이 초과되었습니다. 아래 [코드 재전송] 버튼을 눌러 인증번호를 다시 발급 받으세요.");
      Utils.setCodeTimer($(this).attr('data-target'));
    });
    $(document).on('click', '.btn-step[data-target="#step_1"]', function () {
      $(window).off('beforeunload');
    });
    $(document).on('paste', '.number-list .number-item input:not(:disabled)', function (e) {
      e.preventDefault();

      const clipboardData = e.originalEvent.clipboardData || window.clipboardData;
      const pastedText = clipboardData.getData('text');

      // 숫자만 추출
      const numbers = pastedText.replace(/\D/g, '').split('');

      // 현재 input부터 이후 input들에 숫자 하나씩 넣기
      const $inputs = $('.number-list .number-item input');
      const startIndex = $inputs.index(this);

      numbers.forEach((num, i) => {
        const $input = $inputs.eq(startIndex + i);
        if ($input.length) {
          $input.val(num);
        }
      });

      // 붙여넣기 이후, 다음 빈 input으로 focus 이동
      const nextEmpty = $inputs.toArray().find((input, i) => i >= startIndex && !input.value);
      if (nextEmpty) {
        $(nextEmpty).focus();
      }
    });
    $(document).on('input', '.number-list .number-item input:not(:disabled)', function (e) {
      const inputData = e.originalEvent.data;
      const $numberItem = $(this).closest('.number-item');

      if (inputData) {
        let isValid = /[0-9]/g.test(inputData);

        if (isValid) {
          $(this).val(inputData);
          $numberItem.next().find('input').trigger('focus');
        } else {
          $(this).val('');
        }
      }
    });
    $(document).on('keydown', '.number-list .number-item input:not(:disabled)', function (e) {
      e.stopPropagation();

      const $numberItem = $(this).closest('.number-item');

      if (e.originalEvent.code == 'ArrowLeft') {
        let $prevInput = $numberItem.prev().find('input');
        setTimeout(function () {
          $prevInput.trigger('select');
        }, 0);
      } else if (e.originalEvent.code == 'ArrowRight') {
        let $nextInput = $numberItem.next().find('input');
        setTimeout(function () {
          $nextInput.trigger('select');
        }, 0);
      } else if (e.originalEvent.code == 'Backspace') {
        let $targetInput = $numberItem.prev().find('input');
        if (e.target.value != '') {
          $targetInput = $numberItem.find('input');
        }

        if ($targetInput.length > 0) {
          $targetInput.val('').focus();
        }
      }
    });
    // #endregion number list event
    // #region sidebar event
    $(document).on('click', '.list-sidebar .sidebar-link', function () {
      const $sidebarDetail = $(this).closest('.list-sidebar').find('.sidebar-detail');
      const $targetDetail = $($(this).attr('data-target'));

      if ($(this).hasClass('active')) {
        $sidebarDetail.removeClass('active');
        $(this).removeClass('active');
      } else {
        $(this).parent().siblings().find('.sidebar-link').removeClass('active');
        $(this).addClass('active');
        $targetDetail.siblings().addClass('d-none');
        $targetDetail.removeClass('d-none');

        if (!$sidebarDetail.hasClass('active')) {
          $sidebarDetail.addClass('active');
        }
      }
    });
    $(document).on('click', '.list-sidebar .result-link', function (e) {
      const $resultItem = $(this).closest('.result-item');

      if (!$(this).hasClass('active')) {
        $resultItem.siblings().find('.result-link').removeClass('active');
        $(this).addClass('active');
      }
    });
    // #endregion sidebar event
    // #region custom select2-search event
    $(document).on('click', '.search-selected-list .btn-remove', function (e) {
      $(this).closest('.search-selected-item').remove();
    });
    // #endregion custom select2-search event
    // #region input wrap event
    $(document).on('input focus', '.input-wrap input, .input-wrap textarea', function () {
      const $btnClear = $(this).closest('.input-wrap').find('.btn-clear');

      if ($(this).val().trim() != '') {
        $btnClear.removeClass('d-none');
      } else {
        $btnClear.addClass('d-none');
      }
    });
    $(document).on('input focus', '.contenteditable-wrap .contenteditable', function () {
      const $btnClear = $(this).closest('.input-wrap').find('.btn-clear');

      if ($(this).html() != '') {
        $btnClear.removeClass('d-none');
      } else {
        $btnClear.addClass('d-none');
      }
    });
    $(document).on('mousedown', '.input-wrap .btn-clear', function () {
      const $input = $(this).closest('.input-wrap').find('input');
      const $contenteditable = $(this).closest('.input-wrap').find('.contenteditable');
      $contenteditable.html('');
      $input.val('').trigger('input');
    });
    // #endregion input wrap event
    // #region add input wrap
    $(document).on('click', '.add-input-list .btn-add', function () {
      const $addInputList = $(this).closest('.add-input-list');
      const $newItem = $(this).closest('.add-input-item').clone();
      $newItem.find('.contenteditable').html('');
      $newItem.find('input').val('');
      $newItem.find('input').attr('id', '');
      $newItem.find('.btn').removeClass('btn-add');
      $newItem.find('.btn').addClass('btn-remove');
      $newItem.find('.btn').html($newItem.find('.btn').html().replace('추가', '삭제'));
      $newItem.find('.btn i').text('delete_outline');
      $newItem.find('.btn i').addClass('text-danger');

      $addInputList.append($newItem);

      Utils.setInputmask();
    });
    $(document).on('click', '.add-input-list .btn-remove', function () {
      const $addInputList = $(this).closest('.add-input-list');
      const addInputLength = $addInputList.find('.add-input-item').length;
      const defaultValue = $addInputList.attr('data-default');

      if (!defaultValue || (defaultValue && defaultValue < addInputLength)) {
        $(this).closest('.add-input-item').remove();
      }
    });
    // #endregion add input wrap
    // #region tag event
    $(document).on('keydown', '.tag-wrap input', function (e) {
      if (e.originalEvent.isComposing) return;

      let value = Utils.getEscapeHtml($(this).val().trim(), ['i']);
      let validValue = $(this).val().trim().replace(/<\/?i>/g, '').replace(/\s+/g, '');
      const $contenteditableWrap = $(this).closest('.contenteditable-wrap');
      const $tagList = $(this).closest('.tag-wrap').find('.tag-list');
      const valueArr = $tagList.find('input').map((index, input) => {
        return $(input).val().replace(/<\/?i>/g, '').replace(/\s+/g, '');
      }).get();

      if (e.code == 'Enter') {
        $(this).removeClass('is-invalid');
        $(this).closest('.tag-wrap').find('.invalid-feedback').remove();

        if (value == '') return;
        
        if (valueArr.includes(validValue)) {
          $(this).addClass('is-invalid');

          if($contenteditableWrap.length > 0) {
            $contenteditableWrap.after('<p class="invalid-feedback">이미 존재하는 태그입니다.</p>');
          } else {
            $(this).after('<p class="invalid-feedback">이미 존재하는 태그입니다.</p>');
          }
          return;
        }

        if (value.length > 100) {
          $(this).addClass('is-invalid');

          if($contenteditableWrap.length > 0) {
            $contenteditableWrap.after('<p class="invalid-feedback">태그는 100자 이내로만 작성 가능합니다.</p>');
          } else {
            $(this).after('<p class="invalid-feedback">태그는 100자 이내로만 작성 가능합니다.</p>');
          }
          return;
        }

        $(this).val('').trigger('input');
        $(this).prev('.contenteditable').html('').trigger('input');
        $tagList.append(`
        <li class="tag-item">
          <input type="hidden" name="${$(this).attr('name')}" value="${value}" />
          <span class="value">${value}</span>
          <button type="button" class="btn-icon btn-remove">
            <i class="material-icons">cancel</i>
          </button>
        </li>
        `);
      }
    });
    $(document).on('click', '.tag-wrap .btn-remove', function (e) {
      $(this).closest('.tag-item').remove();
    });
    // #endregion tag event
    // #region input number event
    $(document).on('input', 'input.integer', function () {
      if (!$(this)[0].cleave) {
        $(this)[0].cleave = true;
        new Cleave($(this)[0], {
          numeral: true,
          numeralDecimalMark: '',
          numeralPositiveOnly: true,
          numeralDecimalScale: 0,
          numeralThousandsGroupStyle: 'none',
        });
      }
    });
    // #endregion input number event
    // #region textarea event
    $(document).on('input focus', 'textarea', function () {
      if (!$(this).hasClass('original')) {
        $(this).css('height', 48);
        if ($(this).innerHeight() < $(this)[0].scrollHeight) {
          $(this).css('height', $(this)[0].scrollHeight + 2);
        }
      }
    });
    // #endregion textarea event
    // #region custom tab event
    $(document).on('change', '[data-toggle="custom-tab"]', function () {
      const $target = $($(this).attr('data-target'));
      const isShow = $(this).attr('data-show') === 'true';
      const $customTabElList = $(this).closest('.custom-checked-list').find('[data-toggle="custom-tab"]');

      $customTabElList.each((index, el) => {
        $($(el).attr('data-target')).addClass('d-none');
      });

      if (isShow) {
        $target.removeClass('d-none');
      } else {
        $target.addClass('d-none');
      }
    });
    // #endregion custom tab event
    // #region expand event
    $(document).on('click', '.log-group .btn-expand', function () {
      const $logGroup = $(this).closest('.log-group');
      const $activeLogList = $logGroup.find('.log-item:not(.d-none)');
      const defaultLength = $(this).attr('data-default');

      if ($activeLogList.length == defaultLength) {
        $logGroup.find('.log-item.d-none').removeClass('d-none');
        $(this).html('변경 내용 접기<i class="material-icons ml-8">expand_less</i>');
      } else {
        $logGroup.find('.log-item:nth-of-type(n+6)').addClass('d-none');
        $(this).html('변경 내용 펼치기<i class="material-icons ml-8">expand_more</i>');
      }
    });
    $(document).on('click', '.card-group .btn-expand', function () {
      const $cardGroup = $(this).closest('.card-group');
      const $activeCardList = $cardGroup.find('.card-member:not(.d-none)');
      const defaultLength = $(this).attr('data-default');

      if ($activeCardList.length == defaultLength) {
        $cardGroup.find('.card-member.d-none').removeClass('d-none');
        $(this).html('접기<i class="material-icons ml-8">expand_less</i>');
      } else {
        $cardGroup.find('.card-member:nth-of-type(n+6)').addClass('d-none');
        $(this).html('펼치기<i class="material-icons ml-8">expand_more</i>');
      }
    });
    $(document).on('click', '.info-group .btn-expand', function () {
      const $infoGroup = $(this).closest('.info-group');
      const $activeInfoList = $infoGroup.find('.info-item:not(.d-none)');
      const defaultLength = $(this).attr('data-default');

      if ($activeInfoList.length == defaultLength) {
        $infoGroup.find('.info-item.d-none').removeClass('d-none');
        $(this).html('접기<i class="material-icons ml-8">expand_less</i>');
      } else {
        $infoGroup.find('.info-item:nth-of-type(n+6)').addClass('d-none');
        $(this).html('펼치기<i class="material-icons ml-8">expand_more</i>');
      }
    });
    // #endregion expand event
    // #region Set Drag and Drop File
    $(document).on('dragenter', '.upload-wrap', function () {
      $(this).addClass('active');
    });
    $(document).on('dragleave drop', '.upload-wrap input[type="file"]', function () {
      const $uploadWrap = $(this).closest('.upload-wrap');
      $uploadWrap.removeClass('active');
    });
    $(document).on('change', '.upload-wrap input[type="file"]', function () {
      const is_img = $(this).hasClass("imgfile");
      const files = $(this)[0].files;
      const $uploadWrap = $(this).closest('.upload-wrap');
      const $uploadList = $uploadWrap.next('.upload-list');
      const $uploadInputList = $uploadList.find('.upload-item input');
      const targetValidBtn = $uploadWrap.attr('data-target');
      const validExtArr = $uploadWrap
        .find('input')
        .attr('accept')
        .split(',')
        .map((ext) => ext.replace('.', '').trim());

      const sizeLim = $(this).data('size') ? $(this).data('size') * 1024 * 1024 :  null; // MB 기준
      
      if (files.length > 0) {
        // Validation
        for (let i = 0; i < files.length; i++) {
          
          if (!validExtArr.includes(Utils.getFileDetail(files[i], true).ext)) {
            Utils.showToast("danger", `${validExtArr.join(', ')} 파일 확장자만 업로드 가능합니다.`);
            $(this).val('');
            return;
          }
          let fileSize = Utils.getFileDetail(files[i], true).size;
          for (let j = 0; j < $uploadInputList.length; j++) {
            if (
              Utils.getFileDetail($uploadInputList[j].files[i]).originalName == Utils.getFileDetail(files[i], true).originalName && Utils.getFileDetail($uploadInputList[j].files[i]).size == fileSize
            ) {
              Utils.showToast("danger", '이미 업로드한 파일입니다.');
              $(this).val('');
              return;
            }
          }
          if(sizeLim && fileSize>sizeLim) {
            Utils.showToast("danger", "파일 사이즈를 확인해 주세요.");
            $(this).val('');
            return;
          }
        }

        for (let i = 0; i < files.length; i++) {
          const file = files[i];

          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(file);

          const newFileInput = document.createElement('input');
          newFileInput.type = 'file';
          newFileInput.name = $(this).attr('name');
          newFileInput.classList.add('sr-only');
          newFileInput.files = dataTransfer.files;

          if(is_img) {
            // 인풋 태그에 파일이 있는 경우
            if(files[i]) {
              let imgName = Utils.getFileDetail(files[i], true).name;
              // FileReader 인스턴스 생성
              const reader = new FileReader()
              // 이미지가 로드가 된 경우
              reader.onload = e => {
                let img = `
                  <li class="upload-item img">
                    <img src="${e.target.result}" alt="img-${imgName}">
                    <button type="button" class="btn-icon btn-remove">
                      <i class="inco-icons">cancel</i>
                    </button>
                  </li>
                `
                $uploadList.prepend(img);
              }
              // reader가 이미지 읽도록 하기
              reader.readAsDataURL(files[i]);
            }
          } else {
            $uploadList.prepend(`
            <li class="upload-item">
              <div class="icon-wrap" data-ext="${Utils.getFileDetail(files[i], true).ext}"></div>
              <div class="info-wrap">
                <p class="file-info">
                  <span class="file-name">${Utils.getFileDetail(files[i], true).name}</span>
                  <span class="file-ext">.${Utils.getFileDetail(files[i], true).ext}</span>
                </p>
              </div>
              <button type="button" class="btn-icon btn-remove">
                <i class="inco-icons">clear</i>
              </button>
            </li>
            `);
          }
          //<p class="file-size">${Utils.byteFormatter(Utils.getFileDetail(files[i], true).size)}</p>
                    setTimeout(() => {
            $uploadList.find('.upload-item:first-of-type').append(newFileInput);
          }, 100);
        }

        $(this).val('');
        $(targetValidBtn).attr('disabled', false);
      }
    });
    $(document).on('click', '.upload-list .btn-remove', function () {
      const $uploadList = $(this).closest('.upload-list');
      const $uploadWrap = $uploadList.prev('.upload-wrap');
      const targetValidBtn = $uploadWrap.attr('data-target');

      if ($(this).closest('.upload-item').siblings().length == 0) {
        $(targetValidBtn).attr('disabled', true);
      }

      $(this).closest('.upload-item').remove();
    });
    // #endregion Set Drag and Drop File
  }
  /**
     * Set Tooltip
     */
  function setTooltip() {
    $(document).on('mouseenter', '[data-toggle="tooltip"]', function () {
      $(this).tooltip({
        content: function () {
          return $(this).prop('title');
        },
      });
      $(this).tooltip('open');
    });
  };
  /**
   * Set Table Checkbox
   */
  function setTableCheckbox() {
    $(document).on('change', '.ta-table-wrap input.all', (e) => {
      let $tableWrap = $(e.target).parents('.ta-table-wrap');
      let $eachCheckboxList = $tableWrap.find('input.each');
      $eachCheckboxList.prop('checked', $(e.target).prop('checked'));
    });
    $(document).on('change', '.ta-table-wrap input.each', (e) => {
      let $tableWrap = $(e.target).parents('.ta-table-wrap');
      let $allCheckbox = $tableWrap.find('input.all');
      let $eachLength = $tableWrap.find('input.each').length;
      let $eachCheckedLength = $tableWrap.find('input.each:checked').length;
      if ($eachLength == $eachCheckedLength) {
        $allCheckbox.prop('checked', true);
      } else {
        $allCheckbox.prop('checked', false);
      }
    });
  };
  function setTableBtn() {
    let select2Opt = Utils?.setSelect2Opt();
    $(document).on('click', '.btn-table-plus', (e) => {
      if(!select2Opt) select2Opt = Utils.setSelect2Opt();
      let $table = $(e.target).parents('.ta-table-container').find('table');
      const $lastTr = $table.find('tbody tr:last');

      // 복제 전 select2 해제
      $lastTr.find('select.select2-hidden-accessible').each(function() {
        $(this).select2('destroy');
      });
  
      const $newTr = $lastTr.clone();
      // 새 행의 인덱스 (1부터 시작)
      const rowIndex = $table.find('tbody tr').length + 1;
      // 복제된 행의 input, select 처리
      $newTr.find('input, select, textarea').each(function() {
        const $el = $(this);
        // 기존 ID
        const oldId = $el.attr('id');
        // ID 변경 (id가 있을 때만)
        if (oldId) {
          const newId = oldId.replace(/_\d+$/, `_${rowIndex}`);
          $el.attr('id', newId);
        }

        // 값 초기화
        if ($el.is('select')) {
          $el.prop('selectedIndex', 0); // 첫 옵션 선택
        } else if ($el.is(':checkbox') || $el.is(':radio')) {
          $el.prop('checked', false);
        } else {
          $el.val('');
        }
      });
      // 복제된 행의 라벨
      $newTr.find('label').each(function() {
        const $el = $(this);
        // 기존 ID
        const oldId = $el.attr('for');
        // ID 변경 (id가 있을 때만)
        if (oldId) {
          const newId = oldId.replace(/_\d+$/, `_${rowIndex}`);
          $el.attr('for', newId);
        }
      });
      // 새 행 추가
      $table.find('tbody').append($newTr);

      // 행의 select2 다시 초기화
      $newTr.find('select').each(function() {
        $(this).select2(select2Opt); // select2 다시 활성화
      });
      $lastTr.find('select').each(function() {
        $(this).select2(select2Opt);
      });
    });
    $(document).on('click', '.btn-table-minus', (e) => {
      let $table = $(e.target).parents('.ta-table-container').find('table');
      const $lastTr = $table.find('tbody tr:last');
      const trLen = $table.find('tbody tr').length;
      if(trLen > 1) $lastTr.remove();
    });
    // tabulator
    $(document).on('click', '.btn-tabulator-download', function() {
      let tableId = $(this).data('table');
      let $table = $(`#${tableId}`);
      let checkedId = [];
      let name = $(this).parents(".ta-table-title").find("h3").clone().children().remove().end().text().trim() + " 목록";
      name = name ?? "테이블 목록 다운로드";
      $table.find(`input[name="${tableId}"]:checked:not(.all)`).each((index, el) => {
        let id = $(el).attr('id').split('_')[1];
        checkedId.push(id);
      });
      if(checkedId.length <= 0) {
        Utils.showToast("danger", "다운로드할 항목을 선택해주세요.");
      } else {
        let url = $(this).data('url');
        // Fetch로 다운로드 (에러 응답 처리 가능)
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': CSRFToken
          },
          body: JSON.stringify({ id: checkedId })
        })
        .then(response => {
          // 에러 응답인 경우 (400, 404 등)
          if (!response.ok) {
            return response.text().then(text => {
              Utils.showToast("danger", text || '다운로드에 실패했습니다.');
            });
          }
          // 성공 - 파일 다운로드
          return response.blob();
        })
        .then(blob => {
          // Blob을 파일로 다운로드
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = name+'.xlsx';
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          
          if (Utils && Utils.showToast) {
            Utils.showToast('success', '다운로드가 완료되었습니다.');
          }
        })
        .catch(error => {
          console.error('다운로드 오류:', error);
          if (Utils && Utils.showToast) {
            Utils.showToast('danger', error.message || '다운로드에 실패했습니다.');
          } else {
            alert(error.message || '다운로드에 실패했습니다.');
          }
        });
      }
    });
    $(document).on('click', '.btn-tabulator-delete', function() {
      let tableId = $(this).data('table');
      let $table = $(`#${tableId}`);
      let checkedId = [];
      $table.find(`input[name="${tableId}"]:checked:not(.all)`).each((index, el) => {
        let id = $(el).attr('id').split('_')[1];
        checkedId.push(id);
      });
      if(checkedId.length <= 0) {
        Utils.showToast("danger", "삭제할 항목을 선택해주세요.");
      } else {
        // TODO: 나중에 다운로드 ajax 붙이기
        fetch(tableDeleteUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': CSRFToken
          },
          body: JSON.stringify({ id: checkedId })
        })
        .then(response => response.json())
        .then(data => {
          if (data.message) {
            Utils.showToast("success", data.message);
            window.location.reload();
          } else if (data.error) {
            Utils.showToast("success", "선택한 항목이 삭제되었습니다.");
          }
        })
        .catch(error => {
          console.error('삭제 오류:', error);
          Utils.showToast("danger", "삭제에 실패했습니다.");
        });
      }
    });
  };
  function setBtnEvent() {    
    // dropdown 안닫히게 커스텀
    $(document).on('click', '.dropdown-select .dropdown-menu', function (e) {
      e.stopPropagation();
    });

    $(document).on('click', '.dropdown-menu button', function (e) {
      // dropdown-item 클래스가 없는 경우
      if (!$(this).hasClass('dropdown-item')) {
        e.stopPropagation(); // 이벤트 버블링 중단 → 메뉴 닫힘 방지
      }
    });

    // common modal
    $(document).on('click', '.btn-commonModal-open', function () {
      $('#commonModal').modal('show')
    });
    // common badge-list .close
    $(document).on('click', '.btn-close', function () {
      $(this).parents("li").remove();
    });

    $(document).on("click", ".answer-box .btn-answer", function() {
      $(".answer-box.btn-answer").removeClass("active");
      $(".answer-box textarea.fa-form").addClass("d-none");
      $(this).parents(".answer-box").find("textarea").removeClass("d-none");
      $(this).addClass("active");
    });
    $(document).on("click", ".question-box .btn-question", function() {
      $(".answer-box.btn-question").removeClass("active");
      $(".question-box textarea.fa-form").addClass("d-none");
      $(this).parents(".question-box").find("textarea").removeClass("d-none");
      $(this).addClass("active");
    });
  };

  // #region Event
  function onSelect2OpenEvent() {
    // Dropdown
    if($(this).hasClass('dropdown')) {
      $('.select2-dropdown').closest('.select2-container').addClass('dropdown');
    } else {
      $('.select2-dropdown').closest('.select2-container').removeClass('dropdown');
    }
    if($(this).hasClass('checkbox')) {
      $('.select2-dropdown').closest('.select2-container').addClass('checkbox');
    } else {
      $('.select2-dropdown').closest('.select2-container').removeClass('checkbox');
    }
    if($(this).hasClass('select-flex')) {
      $('.select2-dropdown').closest('.select2-container').addClass('select-flex');
    } else {
      $('.select2-dropdown').closest('.select2-container').removeClass('select-flex');
    }
    if($(this).hasClass('sm')) {
      $('.select2-dropdown').closest('.select2-container').addClass('sm');
    } else {
      $('.select2-dropdown').closest('.select2-container').removeClass('sm');
    }
    if($(this).hasClass('table-views')) {
      $('.select2-dropdown').closest('.select2-container').addClass('table-views');
    } else {
      $('.select2-dropdown').closest('.select2-container').removeClass('table-views');
    }
    if($(this).hasClass('no-m-width')) {
      $('.select2-dropdown').closest('.select2-container').addClass('no-m-width');
    } else {
      $('.select2-dropdown').closest('.select2-container').removeClass('no-m-width');
    }
    // 출장 인원
    // let $selectDouble;
    // if($(this).hasClass('select-double')) {
    //   // 먼저 앞전의 요소 제거
    //   $('.select2-container .select-double-container').remove();
    //   if($selectDouble == undefined) {
    //     const $select2Dropdown = $('.select2-dropdown .select2-results');
    //     $select2Dropdown.find('.select2-results__options').addClass('d-none');
    //     const $select2Double = $(this).parents('.select-double-wrap').find('.select-double-container').clone();
    //     $select2Dropdown.append($select2Double);
    //   }
    //   $selectDouble = $(this);
    // } else {
    //   $('.select2-dropdown').closest('.select2-container').removeClass('select-double');
    // }

    // $(document).on('click', '.btn-select2-selected-add', function() {
    //   if($selectDouble != undefined) {
    //     //$selectDouble.select2('open'); // Open the Select2 dropdown
    //     setTimeout(() => $('.select2-container .select-double-container').remove(), 100);
    //     setTimeout(() => $('.select2-container .select2-dropdown .select2-results__options').removeClass('d-none'), 100);
    //   }
    // });

    // $(document).on('click', function (e) {
    //   // Check if the click is outside of `.select-double-wrap` and `.select-double-container`
    //   if (!$(e.target).closest('.select-double-wrap').length) {
    //     $('.select-double-container .select2-dropdown').removeClass('show');
    //   }
    // });

    $('.select2-container--open .select2-dropdown .btn-link').remove();

  }
  function onSelect2SelectEvent(e) {
    const $selectedOptions = $(this).find('option:selected');

    if($(this).is('.checkbox:not(.no-m-width)')) {
      let justSelected = e.params.data.id;
      
      // 지금 선택한 값이 all 일 경우
      if(justSelected == 'all') {
        // all == true 라면 다른 option select 제거
        if(e.params.data.selected) {
          this.value = 'all';
        }
      } else {
      // 지금 선택한 값이 all 이 아닐경우,
        // 선택 값 길이
        let optCheckedLength = 0;
        [...this.selectedOptions].forEach((option) => {
          optCheckedLength += 1;
          if(option.value == 'all' && e.params.data.selected) {
            // 선택된 옵션들 중 all 값 해제
            option.selected = false;
            // 선택 해제 시 길이 -1
            optCheckedLength -= 1;
          }
        });
        // all 제외 모든 값 길이
        let optAllLength = this.options.length;
        [...this.options].forEach(opt => {
          if(opt.value == 'all') optAllLength -= 1;
        })
        // 주어진 옵션길이와 체크된 옵션 길이가 같으면 all
        if(optAllLength == optCheckedLength) {
          if(e.params.data.selected) {
            this.value = 'all';
          }
        }
      }
      // 만약 아무 선택도 없으면, -> all
      if([...this.selectedOptions].length <= 0) {
        this.value = 'all';
      }
      
      $(this).trigger('change'); // select2에 값 변경 알림
      syncAriaSelected(this);
    }

    if($(this).hasClass('keeptext')) {
      let span = $(this).next('.select2-container--default').find('.select2-selection ul');
      span.html(`<li>${$(this).attr('data-placeholder')}</li>`);
      //setTimeout(() => {
      //  span.html(`<li>${$(this).attr('data-placeholder')}</li>`);
      //}, 10);
    }

    // multiple에서 검색 후 옵션 선택시 검색 바 초기화
    if($(this).attr('multiple')) {
      $(this).next('.select2-container--default').find('.select2-selection .select2-search__field').val('');
    }

    if($selectedOptions.length > 0) {
      let $container = $(this).next().find('.select2-selection__rendered');
      let label = $selectedOptions.attr('data-label');
      let badge = $selectedOptions.attr('data-badge');

      // Dropdown
      if($(this).hasClass('dropdown')) {
        $('.select2-dropdown').closest('.select2-container').addClass('dropdown');
      }
      if(label) {
        if($(this).attr('multiple')) {
          $container = $container.find('.select2-selection__choice');
          $container.addClass('d-flex align-items-center');
          $container.each((index, el) => {
            label = $selectedOptions.eq(index).attr('data-label');
            $(el).prepend(`
            <span class="custom-label-${label}">
              <span class="label-${label}">${$(el).text().substr(-2)}</span>
              <span class="d-flex align-items-center flex-row-reverse">
                ${$(el).html()}
              </span>
            </span>
            `);
            $(el).find('[class^=custom-label-] .select2-selection__choice__remove').remove();
          });
        } else {
          $container.addClass('d-flex align-items-center');
          $container.html(`
          <span class="custom-label-${label}">
            <span class="label-${label}">${$selectedOptions.html().substr(-2)}</span>
            <span class="d-flex align-items-center flex-row-reverse">
              ${$selectedOptions.html()}
            </span>
          </span>
          `);
        }
      }
      if(badge) {
        $container.addClass('d-flex align-items-center');
        $container.html(`
        <span class="custom-badge-${badge}">${$container.text()}</span>
        `);
      }
      if($(this).hasClass('allow-clear')) {
        const $btnRemove = $(this).next('.select2.select2-container').find('.btn-remove');
        $btnRemove.addClass('active');
      } else {
        const $btnRemove = $(this).next('.select2.select2-container').find('.btn-remove');
        $btnRemove.removeClass('active');
      }

      setTimeout(() => {
        if($(this).next().find('input.select2-search__field').length > 0) {
          $(this).next().find('input.select2-search__field').trigger('focus');
        }
      }, 100);
    }
    // For Vue Event
    setTimeout(() => {
      $(this).addClass('d-block');
      $(this).trigger('focus');
      $(this).removeClass('d-block');
    }, 0); 
    document.activeElement.blur();
  }
  function syncAriaSelected(thisEl) {
    const selectedValues = $(thisEl).val() || [];
    $('.select2-results__options [role="option"]').each(function () {
      const value = extractTargetText($(this).data('select2-id'));
      //const value = $(this).data('select2-id').split('-').pop();
      // 선택된 값에 따라 `aria-selected` 업데이트
      $(this).attr('aria-selected', selectedValues.includes(value) ? 'true' : 'false');
    });
  }
  function extractTargetText(input) {
    const parts = input.split('-'); 
    return parts.length > 4 ? parts.slice(4).join('-') : null;
  }
  // #endregion Event 

  return {
    /**
     * Set Datepicker
     */
    setDatepicker() {
      let $datepicker = $('.datepicker');
      $datepicker.datepicker({ 
        dateFormat: 'yy-mm-dd',
        beforeShow: function(input, inst) {
          // readonly면 false 반환 → 달력 안 열림
          if ($(input).prop('readonly')) {
            return false;
          }
        }
      });
      $datepicker.each(function () {
        if ($(this).hasClass('current')) {
          $(this).datepicker('setDate', 'today');
        }
        if ($(this).attr('data-min')) {
          if ($(this).attr('data-min') == 'current') {
            $(this).datepicker('option', 'minDate', 'today');
          } else {
            $(this).datepicker('option', 'minDate', $(this).attr('data-min'));
          }
        }
        if ($(this).attr('data-max')) {
          if ($(this).attr('data-max') == 'current') {
            $(this).datepicker('option', 'maxDate', 'today');
          } else {
            $(this).datepicker('option', 'maxDate', $(this).attr('data-max'));
          }
        }
      });

      let $monthpicker = $('.monthpicker');
      $monthpicker.monthpicker({
        dateFormat: 'm월',      // MM 형식으로 표시
        showButtonPanel: false,    // 완료/오늘 버튼 표시
        monthNames: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'],
        monthNamesShort: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월'],
        beforeShow: function(input, inst) {
          // readonly면 false 반환 → 달력 안 열림
          if ($(input).prop('readonly')) {
            return false;
          }
        }
      });

      $monthpicker.each(function () {
        $(this).attr('autocomplete', 'off');
      //  const val = $(this).val();
      //  $(this).data('value', val).val(val+'월');

      //  if ($(this).attr('data-min')) {
      //    if ($(this).attr('data-min') == 'current') {
      //    } else {
      //      $(this).datepicker('option', 'minDate', $(this).attr('data-min'));
      //    }
      //  }
      //  if ($(this).attr('data-max')) {
      //    if ($(this).attr('data-max') == 'current') {
      //    } else {
      //      $(this).datepicker('option', 'maxDate', $(this).attr('data-max'));
      //    }
      //  }
      });
    },
    /**
     * Set Validation
     */
    setValidation() {
      let elements = document.querySelectorAll('input, textarea');
      for (let i = 0; i < elements.length; i++) {
        elements[i].oninvalid = function (e) {
          e.target.setCustomValidity(' ');
          if (!e.target.validity.valid) {
            elements[i].classList.add('is-invalid');
          }
        };
        elements[i].oninput = function (e) {
          e.target.setCustomValidity(' ');
        };
        if ($(elements[i]).attr('required')) {
          elements[i].focusout = () => {
            // elements[i].classList.remove('is-valid');
            elements[i].classList.remove('is-invalid');
            if (elements[i].value == null || elements[i].value == '') {
              elements[i].classList.add('is-invalid');
            } else {
              // elements[i].classList.add('is-valid');
            }
          };
        }
      }
    },
    /**
     * Set Select2
     */
    setSelect2Opt() {
      let options = {
        //closeOnSelect: false,
        minimumResultsForSearch: 10,
        language: {
          noResults: () => {
            return '검색 결과가 없습니다.';
          },
        },
        escapeMarkup: function(markup) {
          return markup;
        },
        templateResult: (data) => {
          const isBusinessTripMember = $(data.element).closest('.select2').hasClass('business-trip-member')
          const tripTimeStart = $(data.element).attr('data-trip-time-start');
          const tripTimeEnd = $(data.element).attr('data-trip-time-end');
          const isDirectStart = $(data.element).attr('data-is-direct-start');
          const isDirectEnd = $(data.element).attr('data-is-direct-end');
          
          if(isBusinessTripMember && tripTimeStart && tripTimeEnd) {
            return `
            <div class="result-option">
              ${data.text}
              ${
                (() => {
                  if(isDirectStart && isDirectEnd) {
                    return '<span class="badge-sm-round badge-gray-solid">직출/직퇴</span>';
                  }
                  if(isDirectStart && !isDirectEnd) {
                    return '<span class="badge-sm-round badge-gray-solid">직출</span>';
                  }
                  if(!isDirectStart && isDirectEnd) {
                    return '<span class="badge-sm-round badge-gray-solid">직퇴</span>';
                  }
                  return '';
                })()
              }
              <span class="time">${Utils.timeFormat(new Date(tripTimeStart))}~${Utils.timeFormat(new Date(tripTimeEnd))}</span>
            </div>
            `;
          }
          
          return `${data.text}`;
        },
      };
      return options;
    },
    setSelect2() {
      const $select2List = $('select.select2:not(.select2-ajax)');
      
      let options = Utils.setSelect2Opt();

      $select2List.off('select2:open', onSelect2OpenEvent);
      $select2List.off('select2:select', onSelect2SelectEvent);
      $select2List.off('select2:unselect', onSelect2SelectEvent);
      $select2List.on('select2:open', onSelect2OpenEvent);
      $select2List.on('select2:select', onSelect2SelectEvent);
      $select2List.on('select2:unselect', onSelect2SelectEvent);

      $select2List.each(function() {
        $(this).next('span.select2').remove();
        if($(this).hasClass('select-single-search')) {
          options['closeOnSelect'] = true;
        }
        if(this.hasAttribute('multiple')) {
          options['closeOnSelect'] = false;
        }
        $(this).select2(options);

        if($(this).hasClass('keeptext')) {
          let span = $(this).next('.select2-container--default').find('.select2-selection ul');
          span.html(`<li>${$(this).attr('data-placeholder')}</li>`);
        }
        
        if($(this).hasClass('allow-clear') && $(this).val() != '') {
          const btnRemove = '<button type="button" class="btn-remove"><i class="inco-icons">cancel</i></button>';
          $(this).next('.select2.select2-container').append(btnRemove);
        }

        if($(this).find('option').attr('data-badge')
        || $(this).find('option').attr('data-label')
        || $(this).find('option').hasClass('card-member')
        || $(this).find('option').hasClass('card-sales')) {
          $(this).trigger('select2:select');
        }
      });
    },
    /**
     * Set Custom Select
     * if Change Select Call setCustomDropdownSelect(id);
     * @param {String} tagId
     */
    setCustomDropdownSelect(tagId = null) {
      const createCustomDropdownSelect = function (el) {
        let $originalSelect = $(el);
        let $originalOptgroupList = $originalSelect.find('optgroup');
        let $originalOptionList = $originalSelect.find('option');
        let placeholder = '선택';
        let isPlaceholder = false;
        if ($(el).parent().find('.custom-dropdown-select').length <= 0) {
          let newSelect = `
          <div class="dropdown custom-dropdown-select">
          <button class="btn dropdown-toggle" type="button" id="${$originalSelect.attr('id')}Dropdown" ${
            $originalSelect.attr('disabled') ? 'tabindex="-1"' : ''
          } data-toggle="dropdown" aria-expanded="false">
          ${placeholder}
          </button>
          <div class="dropdown-menu custom-dropdown-select" aria-labelledby="${$originalSelect.attr('id')}Dropdown">
          `;
          if ($originalOptgroupList.length > 0) {
            for (let i = 0; i < $originalOptgroupList.length; i++) {
              $originalOptionList = $originalOptgroupList.eq(i).find('option');
              newSelect += `
              <div class="dropdown-optgroup">
              <h6>${$originalOptgroupList[i].label}</h6>
              `;
              for (let j = 0; j < $originalOptionList.length; j++) {
                if ($originalOptionList[j].value == '') {
                  isPlaceholder = true;
                  placeholder = $originalOptionList[j].textContent;
                } else {
                  newSelect += `
                  <a href="javascript:void(0)"
                  class="dropdown-item ${$($originalOptionList[j]).prop('selected') ? 'active' : ''}"
                  data-value="${$originalOptionList[j].value}"
                  data-toggle="tooltip" data-placement="bottom"
                  title="${$originalOptionList[j].title}">
                  ${$originalOptionList[j].text}
                  </a>
                  `;
                }
              }
              newSelect += '</div>';
            }
          } else {
            for (let i = 0; i < $originalOptionList.length; i++) {
              if ($originalOptionList[i].value == '') {
                isPlaceholder = true;
                placeholder = $originalOptionList[i].textContent;
              } else {
                newSelect += `
                <a href="javascript:void(0)"
                class="dropdown-item ${$($originalOptionList[i]).prop('selected') ? 'active' : ''}"
                data-toggle="tooltip" data-placement="bottom"
                data-value="${$originalOptionList[i].value}"
                title="${$originalOptionList[i].title}">
                ${$originalOptionList[i].text}</a>
                `;
              }
            }
          }
          newSelect += `
          </div>
          </div>
          `;
          $originalSelect.after(newSelect);
          $originalSelect.next().find('.btn').text(placeholder);

          if ($(el).parent().find('a.dropdown-item.active').length > 0) {
            $('#' + $originalSelect.attr('id') + 'Dropdown').text($(el).parent().find('a.dropdown-item.active').text());
          } else {
            if (isPlaceholder) {
              $(el).parent().find('.custom-dropdown-select').addClass('dropdown-placeholder');
            }
          }
        }
      };
      if (tagId == null) {
        let $customSelect = $('.ta-custom-dropdown-select-wrap select:not(:disabled)');
        $(document).off('click', '.custom-dropdown-select .dropdown-item');
        $(document).on('click', '.custom-dropdown-select .dropdown-item', function () {
          let $this = $(this);
          setTimeout(function () {
            let $originalSelect = $this.parents('.ta-custom-dropdown-select-wrap').find('select');
            let $originalOptionList = $originalSelect.find('option:not([value=""]');
            let $index = $this.parents('.dropdown-menu').find('.dropdown-item').index($this);
            let $btn = $this.parents('.custom-dropdown-select').find('.btn');
            $originalOptionList.eq($index).prop('selected', true);
            $originalSelect.trigger('change');
            $btn.text($this.text());
            $btn.parent().removeClass('dropdown-placeholder');
            $this.parents('.dropdown-menu').find('.dropdown-item').removeClass('active');
            $this.addClass('active');
            $originalSelect.removeClass('is-invalid');
            $originalSelect.closest('div').parent().find('.invalid-feedback').remove();
          }, 0);
        });
        $customSelect.each((index, el) => {
          createCustomDropdownSelect(el);
        });
      } else {
        let $originalSelect = $(`#${tagId}`);
        $originalSelect.parent().find('.custom-dropdown-select').remove();
        createCustomDropdownSelect($(`#${tagId}`)[0]);
      }
    },
    /**
     * Get Global Variable
     */
    getGlobal() {
      return global;
    },
    /**
     * Get CSS Breakpoint
     */
    getBreakpoint() {
      let breakpoint = getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content');
      breakpoint = breakpoint.replaceAll('"', '');
      return breakpoint;
    },
    /**
     * Get input[type=file] detail
     * @param {Element} elmnt
     * @returns {Object}
     */
    getFileDetail(elmnt) {
      //파일 경로.
      let filePath = elmnt.value;
      let originalFileName;
      let fileName;
      let fileExt;
      let fileSize;
      if(!filePath) {
        originalFileName = elmnt.name;
        fileName =  elmnt.name;
        let lastDot = originalFileName.lastIndexOf('.');
        fileName = originalFileName.substring(0, lastDot);
        fileSize = elmnt.size;
      } else {
        //전체경로를 \ 나눔.
        let filePathSplit = filePath.split('\\');
        // 파일 전체명
        originalFileName = filePathSplit[filePathSplit.length - 1];
        //파일 크기
        fileSize = filePath != '' ? elmnt.files[0].size : null;
      }
      //파일확장자 앞 .의 index
      let lastDot = originalFileName.lastIndexOf('.');
      //파일명 : .으로 나눈 앞부분
      fileName = originalFileName.substring(0, lastDot);
      //파일 확장자 : .으로 나눈 뒷부분
      fileExt = originalFileName.substring(lastDot + 1, originalFileName.length).toLowerCase();
      const object = {
        originalName: originalFileName,
        name: fileName,
        ext: fileExt,
        size: fileSize,
      };

      return object;
    },
    /**
     * Start Loading
     */
    startLoading() {
      let wrapElmnt = document.querySelector('.spinner-wrap');

      if (wrapElmnt) {
        wrapElmnt.dataset.task = Number(wrapElmnt.dataset.task) + 1;
      } else {
        wrapElmnt = document.createElement('div');
        wrapElmnt.classList.add('spinner-wrap');
        wrapElmnt.dataset.task = 1;
        let loadingElmnt = document.createElement('div');
        loadingElmnt.classList.add('spinner-border');
        let span = document.createElement('span');
        span.classList.add('sr-only');
        span.innerHTML = 'Loading...';
        loadingElmnt.appendChild(span);
        wrapElmnt.appendChild(loadingElmnt);

        let body = document.getElementsByTagName('body')[0];
        body.appendChild(wrapElmnt);
      }
    },
    /**
     * End Loading
     */
    endLoading() {
      setTimeout(function () {
        let wrapElmnt = document.querySelector('.spinner-wrap');

        if (wrapElmnt) {
          let taskCount = wrapElmnt.dataset.task;

          if (taskCount > 1) {
            wrapElmnt.dataset.task = Number(wrapElmnt.dataset.task) - 1;
          } else {
            wrapElmnt.style.opacity = 0;
            setTimeout(function () {
              wrapElmnt.remove();
            }, 300);
            let body = document.getElementsByTagName('body')[0];
          }
        }
      }, 300);
    },
    /**
     * Number to KRW format
     * ex) 1000000 -> 1,000,000
     * @param {Number} value
     * @returns {String}
     */
    numberFormatter(value) {
      if (value != '' && value != null && typeof value == 'number') {
        value = String(value)
          .replace(/[^\d]+/g, '')
          .replace(/(^0+)/, '')
          .replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
      } else {
        value = 0;
      }
      return value === '' ? 'NaN' : value;
    },
    /**
     * Byte to size
     * return ex) 5 GB
     * @param {Number} byte
     * @returns {String}
     */
    byteFormatter(byte) {
      let sizes = ['Byte', 'KB', 'MB', 'GB', 'TB'];
      if (byte == 0) return '0 Byte';
      let i = parseInt(Math.floor(Math.log(byte) / Math.log(1024)));
      return Math.round(byte / Math.pow(1024, i), 2) + ' ' + sizes[i];
    },
    /**
     * Set date format
     * @param {String} date
     * @returns {Object}
     */
    dateFormatter(date) {
      if ((date == '' || date == null) && typeof date == 'string') {
        return '';
      }
      const addZero = (num, digits) => {
        var zero = '';
        num = num.toString();

        if (num.length < digits) {
          for (var i = 0; i < digits - num.length; i++) {
            zero += '0';
          }
        }
        return zero + num;
      };
      // Safari Invalid Date 로 인한 replace
      date = date.substring(0, date.lastIndexOf('.')).replace(/-/g, '/').replace('T', ' ');
      let newDate = new Date(date);

      let yyyy = newDate.getFullYear();
      let mm = addZero(newDate.getMonth() + 1, 2);
      let m = newDate.getMonth() + 1;
      let dd = addZero(newDate.getDate(), 2);
      let d = newDate.getDate();

      let object = {
        slash: yyyy + '/' + mm + '/' + dd,
        dot: yyyy + '.' + mm + '.' + dd,
        dash: yyyy + '-' + mm + '-' + dd,
        word: yyyy + '년 ' + m + '월 ' + d + '일',
      };

      return object;
    },
    /**
     * Set  Timer
     * ex) reset => Utils.setCodeTimer('#step_9');, end => Utils.setCodeTimer('#step_9', true);
     * @param {String} targetId
     * @param {Boolean} isEnd
     */
    setCodeTimer(targetId, isEnd) {
      const $target = $(targetId);

      if (global['timer'] != null) {
        clearInterval(global['timer']);
        global['timer'] = null;
      }

      if (isEnd) {
        $target.find('input').attr('disabled', true);
        $target.find('hr').addClass('d-none');
        $target.find('.hide').removeClass('d-none');
      } else {
        $target.find('.count-container .count').text('3:00');
        Utils.setRefresh();

        $target.find('input').val('').attr('disabled', false);
        $target.find('.count-wrap').removeClass('text-warning');
        $target.find('.custom-invalid-feedback').css('display', 'none');
        $target.find('hr').removeClass('d-none');
        $target.find('.hide').addClass('d-none');

        setTimeout(function () {
          let minute = 3;
          let second = 0;

          $target.find('.number-list input').eq(0).trigger('focus');

          global['timer'] = setInterval(function () {
            if (second == 0) {
              if (minute == 0) {
                clearInterval(global['timer']);
                $target.find('input').attr('disabled', true);
                $target.find('.count-wrap').addClass('text-warning');
                $target.find('.custom-invalid-feedback').html("인증시간이 초과되었습니다. 아래 [코드 재전송] 버튼을 눌러 인증번호를 다시 발급 받으세요.")
                $target.find('.custom-invalid-feedback').css('display', 'block');
              } else {
                minute = minute - 1;
                second = 59;
              }
            } else {
              second--;
            }

            let currentTime = minute + ':' + (second < 10 ? '0' + second : second);
            $target.find('.count-container .count').text(currentTime);

            if(minute <= 0 && second <= 0 ) {
              clearInterval(global['timer']);
              global['timer'] = null;
            }
          }, 1000);
        }, 300);
      }
    },
    /**
     * Set Alert for Refresh
     */
    setRefresh() {
      let fnUnload = function (e) {
        e.preventDefault();
        return (e.returnValue = '');
      };
      $(window).on('beforeunload', fnUnload);
    },
    /**
     * Step move event
     * ex) Utils.goStep('#step_1', '#step_2');
     * @param {String} startId
     * @param {String} targetId
     */
    goStep(startId, targetId) {
      setTimeout(() => {
        if (startId == targetId) {
          return;
        }
        const $container = $(startId).closest('.login-main, .step-main');
        const $containerInner = $(startId).closest('.login-main-inner, .step-main-inner');
        const $currentSectionForm = $(startId).closest('section').parent('form').length > 0 ? $(startId).closest('section').parent('form') : $(startId).closest('section');
        const $currentSection = $(startId).closest('section');
        const $targetForm = $(targetId).parent('form') ? $(targetId).parent() : $(targetId);
        const $target = $(targetId);

        $target.css('display', 'block');
        if ($targetForm.index() > 0) {
          $container.find('h1').css('display', 'none');
        } else {
          $container.find('h1').css('display', 'block');
        }
        if ($targetForm.index() > $currentSectionForm.index()) {
          $containerInner.css('transform', `translateX(-${$container.outerWidth()}px)`);
        } else {
          $containerInner.addClass('no-animate');
          $containerInner.css('transform', `translateX(-${$container.outerWidth()}px)`);
          setTimeout(function () {
            $containerInner.removeClass('no-animate');
            $containerInner.css('transform', 'translateX(0)');
          }, 10);
        }
        setTimeout(function () {
          $containerInner.addClass('no-animate');
          $currentSection.css('display', 'none');
          $containerInner.css('transform', 'translateX(0)');
          setTimeout(function () {
            $containerInner.removeClass('no-animate');
          }, 10);
        }, 300);
      }, 100);
    },
    // toast msg
    showToast(type, text) {
      $(`.toast-wrap .toast`).attr('data-type', type);
      $(`.toast-wrap .toast`).find('.toast-title').html(text);
      $(`.toast-wrap .toast`).toast('show');
    },
    // echart
    findPieTooltip(chartID) {
      let chart = document.getElementById(chartID);
      let tooltipWrap = chart.lastChild;
      tooltipWrap.classList.add('pieTool');
    },
    chartPercent(id, dataObj, colorArr) {
      let Chart = echarts.init(document.getElementById(id));
      let Series = [];
      let maxValue = 0;
      let datakey = Object.keys(dataObj);
      // 인증 현황 차트는 중간에 색 변경
      if(id == "certificationStatus") colorArr[3] = '#ced4da';
      if(id == "DataBasic") colorArr[1] = '#ced4da';
      for(let i=0; i<datakey.length; i++) {
        let Sname = datakey[i];
        let Sdata = dataObj[Sname];
        maxValue += Sdata;
        let serie = {
          name: Sname,
          value: Sdata,
          itemStyle: {
            color: colorArr[i],
          },
        };
        Series.push(serie);
      }

      $('#'+id).parents('.chart-postion').find('.count').html(maxValue+'<span>건</span>');

      let optionPie = {
        tooltip: {
          show: true,
        },
        legend: {
          show: true,
          bottom: 0,
          itemGap: 20,
          itemWidth: 18,
          itemHeight: 18,
          padding: [0, 30],
          data: datakey,
          itemStyle: {
            color: 'inherit',
          },
          textStyle: {
            color: 'inherit',
            fontSize: 14
          },
        },
        series: [
          {
            type: 'pie',
            radius: ['60%', '88%'],
            center: ['50%', '40%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: false,
                fontSize: '40',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: Series,
          }
        ],
        // 중앙에 원하는 값 표시
        //graphic: {
        //  type: 'text',
        //  left: 'center',
        //  top: '50%',
        //  style: {
        //    text: parents,
        //    fontSize: 22,
        //    fontWeight: 'bold',
        //    fill: '#4b5864',
        //  },
        //},
        grid: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          containLabel: false // 라벨 공간까지 없애기
        },
        xAxis: { show: false },
        yAxis: { show: false },
      };

      Chart.setOption(optionPie, true);

      Chart.on("legendselectchanged", (event) => {
        let count = Object.keys(event.selected)
        .filter(key => event.selected[key] === true) // 활성화된 것만
        .reduce((sum, key) => sum + (dataObj[key] || 0), 0);
        $('#'+id).parents('.chart-postion').find('.count').html(count+'<span>건</span>');
      });

      //Utils.findPieTooltip(id);
    },
    chartBubble(id, dataArr) {
      let myChart = echarts.init(document.getElementById(id));

      let Series = [];

      let total = dataArr.reduce((sum, item) => sum + item.value, 0);
      
      for (let i=0; i<dataArr.length; i++) {
        let fontSize = (dataArr[i].value / total) * 50;
        Series.push({
          name: dataArr[i].name,
          value: dataArr[i].value,
          symbolSize: (dataArr[i].value / total) * 300, // value 기반 크기
          itemStyle: {
            color: '#38cba11a',
            borderColor: '#38cba11a',
            borderWidth: 1
          },
          label: {
            fontSize: fontSize > 14 ? fontSize : 10
          },
          animation: false
        });
      }

      const option = {
        backgroundColor: '#fff',
        tooltip: {
          formatter: (p) => `${p.data.name}: ${p.data.value}`
        },
        series: [{
          type: 'graph',
          layout: 'force',
          roam: false,       // 🔥 마우스로 움직이기 방지
          draggable: false,  // 🔥 드래그 금지
          label: {
            show: true,
            formatter: '{b}',
            color: '#333',
            fontWeight: '500',
            fontSize: 14
          },
          force: {
            repulsion: 80,   // 원들 간 거리
            edgeLength: 10,
            //gravity: 0
          },
          
          data: Series,
          //data: dataArr.map(item => ({
          //  name: item.name,
          //  value: item.value,
          //  symbolSize: Math.sqrt(item.value) * 5, // value 기반 크기
          //  itemStyle: {
          //    color: 'rgba(153, 231, 220, 0.4)',
          //    borderColor: 'rgba(153, 231, 220, 1)',
          //    borderWidth: 1
          //  },
          //  label: {
          //    fontSize: Math.max(10, Math.sqrt(item.value) * 1.2)
          //  }
          //}))
        }]
      };

      myChart.setOption(option);

    },
    // commonAlert
    commonAlertSet(obj) {
      //obj = {btnClass, type, title, info, btn}
      $('#commonAlert .modal-content').attr('data-type', obj.type);
      $('#commonAlert .title').html(obj.title);
      $('#commonAlert .text').html(obj.info);
      $('#commonAlert .btn-wrap .btn-outline').html(obj.prevBtn);
      $('#commonAlert .btn-wrap .btn-submit').html(obj.naxtBtn);
      if(obj.prevBtn != '') {
        $('#commonAlert .btn-wrap .btn-outline').removeClass('d-none');
      } else {
        $('#commonAlert .btn-wrap .btn-outline').addClass('d-none');
      }
      if(obj.btnClass) {
        $(document).on('click', obj.btnClass, function() {
          $('#commonAlert').modal('show');
        })
      }
    },
    /**
     * Get Scroll Yes or No
    */
    getScrollYN(el) {
      if(el.scrollWidth > el.clientWidth) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * Set Default Tabulator
     * @param {Tabulator} table
    */
    setTabulator(table) {
      table.on('renderComplete', function () {
        var id = '#' + $(this.element).attr('id');
        let $tableSizeSelectOptionList = $(id).find('.tabulator-page-size option');
        // for select custom
        $tableSizeSelectOptionList.each(function () {
          $(this).text($(this).text().replace('개씩 보기', '') + '개씩 보기');
        });
        // for checkbox custom
        let $checkbox = $(id).find('input[type="checkbox"]');
        // custom checkbox
        $checkbox.each(function (index, el) {
          //$(this).addClass('sr-only');
          //if(table.options.selectable) {
          //  $(this).parent().addClass('ta-checkbox-wrap');
          //} else {
          //  $(this).parent().addClass('ta-radio-wrap');
          //}
          //$(this).parent().addClass('ta-checkbox-wrap');
          //$(this).attr('id', `${id.replace('#', '')}_${index}`);
          //$(this).attr('name', `${id.replace('#', '')}`);
          //$(this).parent().find('label').remove();
          //$(this).parent().append(`<label for="${id.replace('#', '')}_${index}">&nbsp;</label>`);
        });
        $('.tabulator .btn-collapse').off().on('click', function () {
          const $originalBtnCollapse = $(this).prev().find('.tabulator-responsive-collapse-toggle');
          $originalBtnCollapse.trigger('click');
          if ($originalBtnCollapse.hasClass('open')) {
            $(this).addClass('collapsed');
          } else {
            $(this).removeClass('collapsed');
          }
        });
        let columns = table.columnManager.columns;
        for(let i = 0; i < columns.length; i++) {
          let el = $(columns[i].contentElement).find('.tabulator-col-title')[0];
          if(Utils.getScrollYN(el)) {
            $(el).attr('data-toggle', 'tooltip');
            $(el).attr('title', $(el).text());
          }
        }
      });
      table.on('tableBuilt', function () {
        // reset checkbox list
        table.getSelectedRows().forEach(function (row) {
          row.deselect();
        });
      });
      table.on('rowSelectionChanged', function (data, rows) {
        if (rows.length > 0) {
          const $parent = $(rows[0]._row.parent.element);
          const $allCheckbox = $parent.siblings('.tabulator-header').find('input[type="checkbox"]');
          const $eachCheckboxList = $parent.find('input[type="checkbox"]');
          if (rows.length == $eachCheckboxList.length) {
            $allCheckbox.prop('indeterminate', false).prop('checked', true);
          }
        }
      });

      if($(".modal-container #tabulatorModal").length <= 0) {
        $(".modal-container").append(`
          <div class="modal fade " id="tabulatorModal" tabindex="-1" data-backdrop="static">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <!-- modal-header -->
                <div class="modal-header">
                  <div class="wrap">
                    <h3>파일 미리보기</h3>
                  </div>
                  <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"><i class="inco-icons">cancel</i></button>
                </div>
                <!-- modal-body -->
                <div class="modal-body">
                  <div class="content-wrap">
                  </div>
                </div>
                <div class="modal-footer btn-wrap"></div>
              </div>
            </div>
          </div>
        `);
      }

    },
    /**
     * Set Default Tabulator Edit Set
     * @param {Tabulator} table
    */
    setTabulatorData(tableID, table, data) {
      let tableFormKey = tableID + "Form";
      tabulatorData[tableID] = table;
      let dataForm = data.length ? JSON.parse(JSON.stringify(data[0])) : [];
      
      // 2️⃣ 값 초기화 (문자열 → "", 불리언 → false, 숫자 → null)
      Object.keys(dataForm).forEach((key) => {
        const value = dataForm[key];
        if (typeof value === "boolean") dataForm[key] = false;
        else if (typeof value === "number") dataForm[key] = null;
        else dataForm[key] = "";
      });
      tabulatorData[tableFormKey] = dataForm;
    },
    setTableEdit() {
      // ✅ 2. 열 추가 버튼 클릭 시
      $(document).on("click", ".tabulator-plus", function () {
        const tableID = $(this).data("table"); // data-table 값
        const table = tabulatorData[tableID];
        const dataForm = tabulatorData[tableID+"Form"];
        if (!table) return;
        // 마지막 row의 ID
        const rows = table.getRows();
        const lastRow = rows[rows.length - 1];
        const lastID = lastRow ? parseInt(lastRow.getData().id) : 1;
        // ID 새로 지정 (예: 기존 최대값 + 1)
        const rowCount = lastID + 1;
        let newRow = JSON.parse(JSON.stringify(dataForm));
        newRow.id = rowCount;
        newRow.selected = false;
        table.addRow(newRow, false);
      });

      // ✅ 2. 열 삭제 버튼 클릭 시
      $(document).on("click", ".tabulator-minus", function () {
        const tableID = $(this).data("table"); // data-table 값
        const table = tabulatorData[tableID];

        const rowCount = table.getDataCount();
        if (rowCount > 0) {
          const selectedRows = table.getRows().filter(row => row.getData().selected);
          if (selectedRows.length === 0) {
            Utils.showToast("danger", "삭제할 행을 선택하세요.");
            return;
          }
          selectedRows.forEach(row => row.delete());
          let msg = selectedRows.length + "개의 행이 삭제되었습니다."
          Utils.showToast("success", msg);

          $(`.tabulator#${tableID} .ta-checkbox-wrap input.all`).prop("checked", false);
        } else {
          Utils.showToast("danger", "삭제할 행이 없습니다.");
        }
      });

      // ✅ 2. 열 - 파일 삭제
      $(document).on("click", ".table-file-remove", function () {
        $("#tabulatorModal").modal("hide");
        const table = tabulatorData[$(this).data("table")];
        const row = table.getRows()[$(this).data("row")];
        row.update({ certified: null });
      });
    },
    getMainSearchFilters() {
      const getMulti = (id) => {
        const el = document.getElementById(id);
        return el ? Array.from(el.selectedOptions).map(opt => opt.value) : [];
      };
      
      const params = new URLSearchParams({
        crop: document.getElementById("searchCrop")?.value || "",
        cultivar: getMulti("searchCultivar").join(","),
        efficacy: getMulti("searchKeyBenefits").join(","),
        component: getMulti("searchKeyIngredients").join(","),
      });
      
      return params;
    },
    setMainSearch(url) {
      if($(".main-search").length == 0) return;
      // 품목을 선택하면 해당 품종 opt로 만들기
      const $searchCrop = $(".main-search .select2.crop");
      if($searchCrop.val() == "") {
        $('.main-search #searchCultivar').attr("disabled", true);
      }

      $searchCrop.on("change", function () {
        const cropId = $(this).val();
        const $cultivarSelect = $('.main-search #searchCultivar');
      
        if (!cropId) {
          $cultivarSelect.prop("disabled", true).empty();
          return;
        }
      
        $.ajax({
          url: url,
          method: 'GET',
          data: { crop_id: cropId },
          success: function (response) {
            $cultivarSelect.empty();
            response.results.forEach(item => {
              const option = new Option(item.value, item.label, false, false);
              $cultivarSelect.append(option);
            });
            $cultivarSelect.prop("disabled", false).trigger("change");
          },
          error: function () {
            Utils.showToast("danger", "품종을 불러오는데 실패했습니다.");
          }
        });
      });
      // 검색 submit
      document.getElementById("filterForm").addEventListener("submit", function(e) {
        e.preventDefault();
        const params = Utils.getMainSearchFilters().toString();
        const baseUrl = window.location.pathname;
        window.location.href = `${baseUrl}?${params}`;
      });
      // 검색 리셋
      $(document).on("click", ".main-search #resetBtn", function() {
        $(this).parents("#filterForm").trigger("reset");
        $(".main-search .select2").val(null).trigger('change');
        $(".main-search input").val(null);
        $(".main-search #searchSubmit").trigger('click');
      });
    },
    // 지역 선택 dropdown 
    setLocation(filePath, depth, colNum) {
      // JSON 파일 불러오기
      fetch(filePath).then(response => response.json()).then(data => {
        const $container = $("#locationContainer");

        // 1️⃣ 시/도 버튼 영역 만들기
        let firstRowHTML = '<div class="row province-first"><input type="hidden" name="city" value="all">';
        let firstBtn = depth == "1" ? "dropdown-item" : "";
        Object.keys(data).forEach((city, i) => {
          firstRowHTML += `
            <div class="col-${colNum}">
              <button type="button" class="btn-depth-1 ${firstBtn}" data-value="${city}">${city}</button>
            </div>
          `;
        });
        firstRowHTML += '</div>';
        $container.html(firstRowHTML);

        // 2️⃣ 첫 번째 시/도 클릭 시, 하위 구/군 버튼 생성
        $(document).on("click", ".dropdown-province .btn-depth-1", function() {
          const city = $(this).data("value");
          const countyList = data[city] || [];
          $(`input[name="city"]`).val(city);

          if(!$(this).hasClass("dropdown-item")) {
            $container.find('.province-first').addClass('d-none');
            let $secondEl = $container.find(".province-second");
            if($secondEl.length == 0) {
              $container.append('<div class="row province-second"><input type="hidden" name="county" value="전체"></div>');
              $secondEl = $container.find(".province-second");
            }
              
            let secondHTML = '<input type="hidden" name="county" value="전체">';
            countyList.forEach((county, j) => {
              secondHTML += `
                <div class="col-${colNum}">
                  <button type="button" class="btn-depth-2 dropdown-item" data-value="${county}">${county}</button>
                </div>
              `;
            });
            $secondEl.html(secondHTML);
          }
          
        });

      });
        $(document).on("click", ".dropdown-province .btn-depth-2", function() {
          const county = $(this).data("value");
          $(`input[name="county"]`).val(county);
        })

      //$(document).on("click", ".dropdown-province .dropdown-item", function() {
      //  let city = $('.dropdown-province input[name="city"]').val();
      //  let county = $('.dropdown-province input[name="county"]').val();
      //  let selectArea = city;
      //  if(county!="전체") selectArea += county
      //  alert(selectArea + " 백에서 받아서 필터 돌려주세용")
      //  $('.dropdown-province .province-first').removeClass('d-none');
      //  $('.dropdown-province .province-second').remove();
      //});
    },
    // 다음 주소 받을 input id(s)
    execDaumPostcode(PostNum, Address, AddressEn, AddressDetail, triggerEl) {
      // 우편번호 검색 설정
      $(document).on("click", `#${Address}`, function() {
        post();
      });
      $(window).keyup(function (e) {
        var code = (e.keyCode ? e.keyCode : e.which);
        if (code == 9 && $(`#${Address}:focus`).length) post();
      });
      function post() {
        new daum.Postcode({
          oncomplete: function(data) {
            document.getElementById(PostNum).value = data.zonecode;
            document.getElementById(Address).value = data.roadAddress;
            if(document.getElementById(AddressEn)) document.getElementById(AddressEn).value = data.addressEnglish;
            document.getElementById(AddressDetail).focus();

            if(triggerEl) {
              document.getElementById(triggerEl).dispatchEvent(new Event('change', { 'bubbles': true }));
            };
          }
        }).open();
      }
    }
  }
})();

function setIndex() {
  $(".layout-header").addClass("index");
  $(document).on("click", ".search-container .dropdown-item", function() {
    $(".search-container .dropdown-toggle").text($(this).text());
    $("#searchText").focus();
    if($(this).data('value') == "material") {
      $("#searchText").val("");
      $("#searchText").attr("placeholder", "품목 및 품종명을 입력해주세요.");
    } else if($(this).data('value') == "farm") {
      $("#searchText").val("");
      $("#searchText").attr("placeholder", "품목을 입력해주세요.");
    }
  });
};

function sampleModalStep() {
  $(document).on('click', '.btn-next', function () {
    $("#sampleModal .step-container section#step_2").css("left", 0);
    $("#sampleModal .step-container section#step_1").css("left", "-100%");
    setTimeout(() => {
      $("#sampleModal .step-container section#step_1").removeClass("active");
      $("#sampleModal .step-container section#step_2").addClass("active");
      $("#sampleModal .btn-next").addClass("d-none");
      $("#sampleModal .btn-prev").removeClass("d-none");
      $("#sampleModal .btn-sample-add").addClass("d-none");
      $("#sampleModal .btn-submit").removeClass("d-none");
    }, 500);
  });
  $(document).on('click', '.btn-prev', function () {
    $("#sampleModal .step-container section#step_1").css("left", 0);
    $("#sampleModal .step-container section#step_2").css("left", "100%");
    setTimeout(() => {
      $("#sampleModal .step-container section#step_1").addClass("active");
      $("#sampleModal .step-container section#step_2").removeClass("active");
      $("#sampleModal .btn-next").removeClass("d-none");
      $("#sampleModal .btn-prev").addClass("d-none");
      $("#sampleModal .btn-sample-add").removeClass("d-none");
      $("#sampleModal .btn-submit").addClass("d-none");
    }, 500);
  });
  
  $(document).on("change", "#step_2", function() {
    let allFilled = true;
    $('#step_2 input').each(function() {
      if (!$(this).val().trim()) {
        allFilled = false;
        return false; // 하나라도 비면 반복 중단
      }
    });
    if(allFilled) {
      $("#sampleModal .btn-submit").attr("disabled", false);
    } else {
      $("#sampleModal .btn-submit").attr("disabled", true);
    }
  })

  $(document).on("change", "#questionModal .input-wrap", function() {
    let allFilled = true;
    $('#questionModal .row .ta-form').each(function() {
      if (!$(this).val().trim()) {
        allFilled = false;
        return false; // 하나라도 비면 반복 중단
      }
      let selectValue = $("#questionModal select").find("option:selected");
      if(!selectValue) allFilled = false;
    });
    if(allFilled) {
      $("#questionModal .btn-submit").attr("disabled", false);
    } else {
      $("#questionModal .btn-submit").attr("disabled", true);
    }
  })
}

function deliveryModal2() {
  $(document).on('click', '#deliveryModal2 .btn-go-cancel', function(){
    $('#deliveryModal2 .delivery-status').addClass("d-none");
    $('#deliveryModal2 .delivery-num').addClass("d-none");
    $('#deliveryModal2 .delivery-cancel').removeClass("d-none");
    $('#deliveryModal2 .btn-go-cancel').addClass("d-none");
    $('#deliveryModal2 .btn-prev').removeClass("d-none");
    $('#deliveryModal2 .btn-cancel').removeClass("d-none");
    $('#deliveryModal2 #cancelReason').focus();
  })
  $(document).on('click', '#deliveryModal2 .btn-prev', function(){
    $('#deliveryModal2 .delivery-status').removeClass("d-none");
    $('#deliveryModal2 .delivery-num').removeClass("d-none");
    $('#deliveryModal2 .delivery-cancel').addClass("d-none");
    $('#deliveryModal2 .btn-go-cancel').removeClass("d-none");
    $('#deliveryModal2 .btn-prev').addClass("d-none");
    $('#deliveryModal2 .btn-cancel').addClass("d-none");
  });
  $('#deliveryModal2').on('hidden.bs.modal', function () {
    $('#deliveryModal2 .delivery-status').removeClass("d-none");
    $('#deliveryModal2 .delivery-num').removeClass("d-none");
    $('#deliveryModal2 .delivery-cancel').addClass("d-none");
    $('#deliveryModal2 .btn-go-cancel').removeClass("d-none");
    $('#deliveryModal2 .btn-prev').addClass("d-none");
    $('#deliveryModal2 .btn-cancel').addClass("d-none");
  });

  $(document).on('input', '#deliveryModal2 #cancelReason', function() {
    if($(this).val() != "") {
      $('#deliveryModal2 .btn-cancel').attr("disabled", false);
    } else {
      $('#deliveryModal2 .btn-cancel').attr("disabled", true);
    }
  });
}

// 편집 가능 여부 전역 변수
//공통 editable 조건 함수 
function editableIfAllowed(cell) {
  const rowData = cell.getRow().getData();
  return isEditable && rowData.id !== "standard"; // 만약 농진청 데이터 있으면
}
//숫자용 editorParams
const numericEditorParams = {
  elementAttributes: { inputmode: "numeric" }
};
//공통 숫자 validator
function numericValidator(cell, value) {
  const isValid = !isNaN(value);
  if(!isValid){
    Utils.showToast("danger", "숫자만 입력 가능합니다!")
  }
  return isValid;
}
function fileFormatter(cell) {
  const value = cell.getValue();
  if (value instanceof File) {
    return `<button class="file-view" title="보기"><i class="inco-icons">file_pdf</i></button>`;
  } else if (typeof value === "string" && value) {
    // 서버에서 받은 파일명(value) 있으면 (이미 업로드된 상태)
    return `<button class="file-view" title="보기"><i class="inco-icons">file_pdf</i></button>`;
  }
  if(isEditable) return `<div class="upload-wrap"><p class="label"><i class="inco-icons">file_pdf</i></p></div>`;
}
// 파일 형식 cell 클릭 시
function fileCellClick(e, cell) {
  const target = e.target;
  const row = cell.getRow();
  let index = row._row.position - 1;
  // 삭제 버튼
  if (target.classList.contains("file-remove")) {
    row.update({ certified: null });
    return;
  }
  // 보기 버튼
  if (target.classList.contains("file-view")) {
    const file = cell.getValue();
    let fileURL = file;
    if (file instanceof File) {
      fileURL = URL.createObjectURL(file);
    }
    // 🔹 PDF / 이미지 미리보기 구분
    const isPDF = file instanceof File
      ? file.type === "application/pdf"
      : file.endsWith(".pdf");

    let fileHTML = "";
    if (isPDF) {
      fileHTML = `
        <div class="preview-wrapper">
          <iframe src="${fileURL}" width="100%" height="434" frameborder="0"></iframe>
        </div>`;
    } else {
      fileHTML = `
        <div class="preview-wrapper text-center">
          <img src="${fileURL}" alt="미리보기" style="max-width:100%; max-height:434px;" />
        </div>`;
    }
    // 🔹 모달 내용 교체
    if(isEditable) {
      $("#tabulatorModal .modal-footer").html(`
        <button type="button" class="btn btn-icon btn-danger table-file-remove" data-table="ingredientsTable" data-row="${index}"><i class="inco-icons">delete</i>삭제</button>
      `);
    }
    $("#tabulatorModal .modal-content .modal-body .content-wrap").html(fileHTML);
    $("#tabulatorModal").modal("show");

    //if (file instanceof File) {
    //  const url = URL.createObjectURL(file);
    //  window.open(url, "_blank");
    //} else if (typeof file === "string") {
    //  window.open(`/uploads/${file}`, "_blank"); // 서버 경로 맞게 수정
    //}
    return;
  }
  // 파일 선택창 열기
  if(!isEditable) return;
  
  const input = document.createElement("input");
  input.type = "file";
  input.accept = ".pdf,.jpg,.png,.jpeg,.xlsx";
  input.addEventListener("change", (e) => {
    const file = e.target.files[0];
    if (file) {
      row.update({ certified: file });
    }
  });
  input.click();
}

// 혹시 몰라서 삭제 안한 버튼 이벤트
function tabulatorEditChange() {


      // ✅ btn-edit 클릭 시 모든 열에 editor 활성화
      $(".btn-table-edit").on("click", function () {
        const columns = table.getColumns();

        columns.forEach((col) => {
          const def = col.getDefinition();

          // ✅ selected 필드는 편집 모드 제외
          if (def.field !== "selected" && !def.editor) {
            // 문자열 필드라면 input, 불리언이면 tickCross
            def.editor = def.formatter === "tickCross" ? "tickCross" : "input";
          }

          // 변경 적용
          col.updateDefinition(def);
        });

        alert("편집 모드가 활성화되었습니다 ✏️");
      });

  document.getElementById("tabulatorEdit").addEventListener("click", function () {
    isEditable = !isEditable;
    this.textContent = isEditable ? "편집 완료" : "수정하기";

    // 테이블 새로 그림 (editable 반영)
    table.redraw(true);

    //if (isEditable) {
    //  table.showColumn("selected"); // ✅ 수정 모드: 체크박스 보이기
    //} else {
    //  table.hideColumn("selected"); // ✅ 읽기 모드: 체크박스 숨기기
    //}

    if (isEditable) {
      alert("이제 편집 가능합니다!");
    } else {
      alert("편집이 완료되었습니다.");
    }
  });
}
